import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=6035c232&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=6035c232&prod&lang=scss&scoped=true"
import style1 from "./Auth.vue?vue&type=style&index=1&id=6035c232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035c232",
  null
  
)

export default component.exports